import { jsx as e } from "react/jsx-runtime";
import { Flex as b, Radio as _ } from "@chakra-ui/react";
import f from "react";
import { hoverStyles as A } from "./hover-styles.js";
import { ThemeColorVariable as r } from "../../theme/theme-types.js";
const k = f.forwardRef(
  ({ value: o, children: c, defaultChecked: t, onChange: d, isChecked: i, isInvalid: a, isDisabled: n, ...l }, m) => /* @__PURE__ */ e(b, { __css: A, ...l, children: /* @__PURE__ */ e(
    _,
    {
      ref: m,
      value: o,
      defaultChecked: t,
      isChecked: i,
      onChange: d,
      isInvalid: a,
      isDisabled: n,
      w: "100%",
      _invalid: {
        borderColor: r.Error,
        boxShadow: `0 0 0 4px ${r.ErrorContainer}`
      },
      _active: {
        borderColor: `${r.AccentActive}`,
        _checked: {
          background: `${r.AccentActive}`,
          borderColor: `${r.AccentActive}`
        },
        _disabled: {
          borderColor: `${r.OnBackground}`,
          _checked: {
            background: `${r.Accent}`,
            borderColor: `${r.Accent}`
          }
        }
      },
      children: c
    },
    o
  ) })
);
export {
  k as Radio
};
